import React, { useEffect, useState, useContext } from "react";
import { useProcessor } from '../../hooks/useProcessor'
import { useCurrencyFormat } from '../../hooks/useCurrencyFormat'
import { usePhoneFormat } from '../../hooks/usePhoneFormat'
import { useLocation, useNavigate } from "react-router"
import { useNotification } from "../../hooks/useNotification";
import { v4 as uuidv4 } from 'uuid'
import { AuthContext } from "../../context/AuthContext";
import FInputt from "../../components/FInputt/FInputt";
import Swal from "sweetalert2";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";

const NotificationDetailScreen = () => {
    const route = useNavigate()
    const { state } = useLocation();
    const { errorMessage, loading, setLoading, setAlert } = useContext(AuthContext);
    const [idempotencyKey, setIdempotencyKey] = useState('');
    const { processPayment } = useProcessor();
    const { formatWithCurrencyISO } = useCurrencyFormat();
    const { phoneNumberWithEmoji } = usePhoneFormat()
    /* format date */

    const dateFormatted = new Date(state.creationDate);
    const day = dateFormatted.getDate();
    const month = dateFormatted.getMonth() + 1;
    const year = dateFormatted.getFullYear();
    const hour = dateFormatted.getHours();
    const minutes = dateFormatted.getMinutes();


    const { markNotificationById } = useNotification();

    useEffect(() => {
        markNotificationById(state.id);
        setIdempotencyKey(uuidv4());
    }, [])





    const nextScreen = async (options) => {

        const data = {
            originCurrencyId: "484",
            destinationCurrencyId: "484",
            exchangeRateId: null,
            products: [
                {
                    id: "FIADO_FUNDS_AVAILABLE_MXN"
                },
                {
                    id: "FIADO_SHARE_MXN",
                    amount: options.amount,
                    beneficiaryDirectoryId: options.beneficiaryDirectoryId,
                    typeOfDirectoryId: "USER",
                    concept: options.concept,
                    saveAsFavorite: false
                }
            ]
        }



        let response = await processPayment(data, idempotencyKey);
        if (response?.data?.code == "PROCESS_OK") {

            const next = () => { route('/') }
            Swal.fire({
                showCloseButton: true,
                title: 'Éxito',
                text: 'La transferencia se ha realizado exitosamente',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                confirmButtonText: 'Entendido'
            }).then((result) => {
                if (result.isConfirmed) {
                    next();
                }
            })
        }
    }

    return (
        <FContainer>
            <div className="w-full  flex justify-center">
                {
                    state.message.options && (state.message.options.type === 'SHARED_FIADO') ?
                        <>
                            <div className="text-center">
                                <div className="border-2 w-full shadow-Box rounded-2xl p-5">
                                    <div className="font-bold text-2xl">Descripción</div>
                                    <div className="text-xl pb-2 font-regular">{state.message.body}</div>
                                    <div className="font-bold text-2xl">Número</div>
                                    <div className="text-xl pb-2 font-regular grid place-items-center">
                                        <FiconPhoneNumber
                                            sizeIcon="24px"
                                            phoneNumber={state.message.options.beneficiaryPhoneNumber}
                                        />
                                    </div>
                                    <div className="font-bold text-2xl">Cantidad</div>
                                    <div className="text-xl pb-2 font-regular">{state.message.options.amount}</div>
                                    <div className="font-bold text-2xl">Concepto</div>
                                    <div className="text-xl pb-2 font-regular">{state.message.options.concept}</div>
                                </div>

                                <Fbutton
                                    value={"Enviar"}
                                    onClick={() => {
                                        nextScreen(state.message.options, idempotencyKey)
                                        //setIsActive(false)
                                    }}
                                />                        </div>
                        </>
                        :
                        <div className="text-center">
                            <div className="font-bold text-2xl">Fecha y hora</div>
                            <div className="text-xl pb-2">{day}/{month}/{year} a las {hour}:{minutes}</div>
                            <div className="font-bold text-2xl">Descripcion</div>
                            <div className="text-xl pb-2">{state.message.body}</div>
                            <div className="font-bold text-2xl">Id de la transacción</div>
                            <div className="text-xl pb-2">{state.transaction.id}</div>
                        </div>
                }

            </div>
        </FContainer>
    )

}

export default NotificationDetailScreen